import React from 'react';
import OverviewCard from '../components/OverviewCard';
import LatestTransactions from '../components/LatestTransactions';
import LastBlocks from '../components/LastBlocks';
import useTitle from '../hooks/useTitle';

const HomePage = () => {
  useTitle("MENELIK - Home");

  return (
    <div className="container mx-auto px-4">
      <h1 className="text-3xl font-bold text-center my-6">Blockchain Explorer</h1>

      <OverviewCard />

      <div className="grid gap-6 md:grid-cols-2">
        <div className="w-full overflow-x-auto bg-white shadow-lg rounded-lg p-4">
          <h2 className="text-xl font-semibold mb-4 text-center">Latest Transactions</h2>
          <LatestTransactions />
        </div>
        <div className="w-full overflow-x-auto bg-white shadow-lg rounded-lg p-4">
          <h2 className="text-xl font-semibold mb-4 text-center">Last Blocks</h2>
          <LastBlocks />
        </div>
      </div>
    </div>
  );
};

export default HomePage;
